export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7647.f1eb33b4.jpg";